import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';
import { useCryptoStore } from '@/stores/crypto-store';
import { ROUTES } from '@/constants/routes';

export function PrivateRoute() {
  const { isAuthenticated, isLocked } = useAuthStore();
  const { isReady } = useCryptoStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Se está autenticado mas a chave de criptografia não está disponível,
  // redireciona para unlock (acontece ao recarregar a página ou voltar para aba)
  if (isLocked || !isReady) {
    return <Navigate to={ROUTES.UNLOCK} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
